// Wire format for phone ↔ TV data channel messages.
// Must match src/services/cast.ts on the phone side.

import type { CameraAngle } from '@/config/exercise3d';

export type WorkoutPhase = 'countdown' | 'active' | 'rest' | 'complete';

// Phone → TV
export type PhoneToTvMessage =
  | { type: 'SET_EXERCISE'; modelName: string; exerciseName?: string; setIndex?: number }
  | { type: 'SET_PLAYBACK'; paused: boolean; speed: number }
  | { type: 'SET_ROTATION'; angle: number }
  | { type: 'SET_CAMERA_ANGLE'; angle: CameraAngle }
  | { type: 'SET_PHASE'; phase: WorkoutPhase; timerSeconds?: number }
  | { type: 'HEARTBEAT'; ts: number };

// TV → Phone
export type TvToPhoneMessage =
  | { type: 'READY' }
  | { type: 'HEARTBEAT_ACK'; ts: number }
  | { type: 'ERROR'; code: string; message: string };

export type CastMessage = PhoneToTvMessage | TvToPhoneMessage;

export function isPhoneMessage(msg: unknown): msg is PhoneToTvMessage {
  if (!msg || typeof msg !== 'object') return false;
  const t = (msg as { type?: unknown }).type;
  return (
    t === 'SET_EXERCISE' ||
    t === 'SET_PLAYBACK' ||
    t === 'SET_ROTATION' ||
    t === 'SET_CAMERA_ANGLE' ||
    t === 'SET_PHASE' ||
    t === 'HEARTBEAT'
  );
}
